import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "ngx-client-delete-column",
  template: `
    <button nbButton size="tiny" status="danger" (click)="delete()" [attr.disabled]="data.deleted">
      삭제
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class ClientDeleteComponent implements ICellRendererAngularComp {

  public params: ICellRendererParams;
  public data: any;

  constructor() { }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;
  }

  ngOnInit() { }

  delete(): void {
    this.params.context.delete(this.data);
  }
  
}
